/**
 * PublicLayout: wrapper para rutas no autenticadas (login,
 * solicitar-acceso, errores genéricos).
 *
 * Sprint 11 v2 S11-V2-03. Centrado, fondo `bg-page`, sin Header naranja.
 * El Login (S11-V2-04) mostrará el escudo grande + el card de magic
 * link dentro de este wrapper.
 */
import { Outlet } from 'react-router-dom';

export function PublicLayout() {
  return (
    <div className="min-h-screen bg-bg-page flex flex-col items-center justify-center p-4">
      <Outlet />
    </div>
  );
}
